import { useEffect, useRef } from 'react';
import type { RefObject } from 'react';

export const useFocusOnMount = <T extends HTMLElement>(enabled: boolean, key?: unknown): RefObject<T> => {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (enabled) ref.current?.focus();
  }, [enabled, key]);
  return ref;
};
